import { Injectable } from "@angular/core"
import { createAppKit } from "@reown/appkit"
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi"
import { environment } from "src/environments/environment"
import { Config } from "wagmi"
import { polygon, polygonAmoy } from '@reown/appkit/networks';

@Injectable({
    providedIn: 'root'
})
export class walletConfigService {

    connect_wallet_config: any
    config_wagmi_adopter!: Config
    async walletcConnectConfig() {
        const addSuppoortedNetworks = environment.DEFAULT_NETWORK == '137' ? polygon : polygonAmoy
        const metadata = {
            name: 'Real World',
            description: 'RealWorld.fi - Marketplace',
            url: environment.WEB_SITE_URL,
            icons: ['https://avatars.githubusercontent.com/u/37784886']
        }
        const wagmiAdapter: any = new WagmiAdapter({ projectId: environment.WALLET_CONNECT_PROJECT_ID, networks: [addSuppoortedNetworks] })
        this.connect_wallet_config = createAppKit({
            adapters: [wagmiAdapter],
            networks: [addSuppoortedNetworks],
            metadata: metadata,
            projectId: environment.WALLET_CONNECT_PROJECT_ID,
            features: {
                socials: false,
                email: false
            },
            themeVariables: {
                "--w3m-color-mix": "#063f2dff",
                "--w3m-color-mix-strength": 40,
                "--w3m-accent": "#06402dff",
            }
        })
        this.config_wagmi_adopter = wagmiAdapter.wagmiConfig
    }
}